<div class="w-full mt-8 flex flex-col gap-6">
  <div class="flex w-full justify-between items-center">
    <h1 class="py-2 w-full font-bold text-[24px] leading-snug">Uso de Solución IA</h1>
    <div [attr.title]="!canCreateAiSolutionUsage ? noCreateAiSolutionUsagePermissionMessage : null">
      <app-buttons
        [classes]="'bg-primary-base text-white'"
        [label]="'Dar de alta uso de solución IA'"
        [disabled]="!canCreateAiSolutionUsage"
        [routerLink]="'/catalogo-ia/uso-de-solucion-ia/nuevo-uso-de-solucion-ia'" />
    </div>
  </div>
  <div class="text-[16px]">
    Una solución de IA es una herramienta o servicio que incorpora capacidades de inteligencia artificial para apoyar a
    las personas en la realización de tareas y procesos.
    <br />
    En este catálogo se registra el uso previsto de soluciones comerciales de IA dentro del Gobierno de Aragón,
    identificando la herramienta utilizada, su finalidad y el uso concreto que se pretende realizar. Esto permite
    evaluar su adecuación, los riesgos asociados y el cumplimiento de los requisitos normativos aplicables.
  </div>
  <app-search-bar
    [showExternalButton]="true"
    [placeholder]="'Buscar usos de solución IA'"
    (search)="handleSearch($event)" />

  <app-filters
    [filtersAdvanced]="advancedFilters()"
    [title]="'Buscar por filtros'"
    (applyFilters)="handleApplyFilters($event)"
    [containerClass]="'flex flex-wrap gap-x-8 gap-y-6 items-end justify-start max-w-[70%]'" />

  <div class="flex min-w-[1200px] justify-between items-end">
    <span class="text-md font-bold">{{ total() }} usos de solución IA</span>
    <app-dropdown
      [options]="orderby.options ?? []"
      [hiddenArrow]="true"
      [label]="orderby.label ?? ''"
      [icon]="orderby.icon ?? ''"
      [classes]="orderby.classes ?? ''"
      (select)="onDropdownChange($event)" />
  </div>

  <span
    class="text-[16px] font-regular text-neutral-base"
    *ngIf="total() === 0">
    No se encontraron usos de solución IA
  </span>

  <app-ai-solution-usage-card
    *ngFor="let card of cards()"
    [id]="card.id"
    [usageName]="card.usageName"
    [solutionType]="card.solutionType"
    [state]="card.state"
    [requestingPerson]="card.requestingPerson"
    [creationDate]="card.creationDate"
    [infoCard]="card.infoCard"
    [expectedUse]="card.expectedUse"
    [showReviewButton]="canReviewAiSolutionUsage" />

  <app-pagination
    [totalItems]="total()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
